import React, { Component } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { GETCOURSEBYIDACTION } from "store/Ilearn";
import { connect } from "react-redux";
// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
import { Bookmark, MapPin, ChevronRight, ChevronLeft } from "react-feather";
// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation } from "swiper/core";
import courseslogo from "views/home/img/courses/courselogo.png";
import TrendingJobs1 from "views/home/img/courses/course1.png";
import TrendingJobs2 from "views/home/img/courses/course2.png";
import TrendingJobs3 from "views/home/img/courses/course3.png";
import TrendingJobs4 from "views/home/img/courses/course4.png";
import bookmark from "views/home/img/bookmark.svg";
// import { render } from "node-sass";
// install Swiper modules
SwiperCore.use([Pagination, Navigation]);

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      courses: {},
      RelatedCoursess: [],
      RelatedCoursesIds: [],
    };
  }
  async getRelatedCourses() {
    if (this.props.Course) {
      try {
        let Course = this.props.Course;
        let RelatedCoursesIds = Course.c_relatedCourses.split(",");
        // console.log(Course.c_relatedCourses.split(","))
        // let RelatedCoursesIds = []
        // RelatedCoursesIds =`${Course.c_relatedCourses}`.split(",");
        let RelatedCourses = [];
        // // debugger;
        for (let i = 0; i < RelatedCoursesIds.length; i++) {
          let payload = {
            CourseId: RelatedCoursesIds[i],
          };
          this.props
            .getCoursesById(payload)
            .then((res) => {
              RelatedCourses.push(res.data.Data[0]);
              this.setState({ RelatedCourses: RelatedCourses });
            })
            .catch((err) => console.log(err));
        }
        // debugger;
        this.setState({ RelatedCoursess: RelatedCourses });
     
      } catch (err) {
        // console.log(err);
      }
    }
    // console.log(this.state.RelatedCourses)
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.Course !== this.props.Course) {
     // this.getRelatedCourses();
    }
  }
  async componentDidMount() {
    // this.getRelatedCourses();
  }
  addDefaultSrc(ev) {
    ev.target.src = TrendingJobs1;
  }
  render() {
    let RelatedCourses = this.state.RelatedCoursess;

    return (
      <>
        <div className='flex justify-between items-center  mb-8'>
          <h2 className='fsize28 font-bold sm-fsize16'>VIEW SIMILAR COURSES</h2>
          <div className='flex '>
            <ChevronLeft
              width='30px'
              height='30px'
              className='trend-left-i mr-2'
            />
            <ChevronRight
              width='30px'
              height='30px'
              className='trend-right-i'
            />
          </div>
        </div>
        <Swiper
          breakpoints={{
            1366: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            991: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            425: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            375: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 15,
            },
          }}
          slidesPerGroup={4}
          loop={true}
          loopFillGroupWithBlank={true}
          pagination={{
            clickable: true,
          }}
          navigation={false}
          className='mySwiper swiperpagination-dot'
        >
          {RelatedCourses.map((course) => (
            <SwiperSlide className='shadow-lg rounded-12px mb-4 showcard'>
              <div className='img__wrap w-full'>
                <div>
                  <div className='relative'>
                    <img
                      onError={this.addDefaultSrc}
                      src={`http://localhost:3001/${course.c_path}`}
                      className='sm-h126px   w-full rounded-t-lg h-222px  object-fill '
                      alt='banner-img '
                    />
                    <div className='absolute bookmark-parent text-white rounded-full'>
                      <img
                        src={bookmark}
                        alt='bookicon'
                        className='bookmark-t-c'
                      />
                    </div>
                  </div>
                  <div className='relative'>
                    <img
                      src={courseslogo}
                      alt='course'
                      className='courses-logo'
                    />
                    <div className='lg:px-8 md:px-8 lg:pt-12 md:pt-12 lg:pb-6 md:pb-6 px-4 pt-6 pb-4  '>
                      <p className='text-black text-left line-clamp-2 font-bold fsize20 sm-fsize12'>
                        {course.c_title || "The Course"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className='img__description_layer'>
                  <h1 className=' img__description trend-hover-h sm-fsize11 '>
                    {course.c_category || "Human Resource"}
                  </h1>

                  <p className='text-black font-bold  lg:px-6 md:px-6  px-2  lg:my-6  md:my-6 my-2   fsize18 sm-fsize12 '>
                    {course.c_title || "The Course"}
                  </p>
                  <p className='cust-textmuted1 lg:px-8 md:px-8  fsize14  lg:mb-6 md:mb-6 mb-2 sm-fsize10'>
                    {course.c_short_description || "this is short description"}
                  </p>
                  <p className='course-total flex justify-center px-6 fsize14  lg:mb-6 md:mb-6 mb-2  sm-fsize9'>
                    <ul>
                      <li className='cust-list-bullet'>6 Courses (12h)</li>
                    </ul>
                  </p>

                  <p className='text-black  lg:px-6 md:px-6 px-2 fsize14 font-medium sm-fsize9'>
                    <span className=''>
                      {" "}
                      {course.start_date && course.end_date
                        ? course.start_date + " - " + course.end_date
                        : "Forever"}
                    </span>
                  </p>

                  <div className='flex justify-center'>
                    <button className='cust-trendapply-btn flex'>
                      ENROLL{" "}
                    </button>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    SINGLECOURSE: state.iLearn.course.SINGLECOURSE,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCoursesById: async (payload) =>
      await dispatch(GETCOURSEBYIDACTION(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
